function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import AddManualTime from "../AddManualTime";
import ManualTimeEntriesReview from "../ManualTimeEntriesReview";
// import "./PersonalSettings.css";
import { Helmet } from "react-helmet";
import { UserContext, FilterContext } from "../index";
var ManualTime = function ManualTime(props) {
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    role = _React$useContext2.role,
    organisationSettings = _React$useContext2.organisationSettings,
    from = _React$useContext2.from,
    organisationBilling = _React$useContext2.organisationBilling;
  var _React$useState = React.useState("add-manual-time"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeManualTab = _React$useState2[0],
    setActiveManualTab = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    unreviewedTaskCount = _React$useState4[0],
    setUnreviewedTaskCount = _React$useState4[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  useEffect(function () {
    // 👇️ scroll to top on page load
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth"
    });
  }, []);
  useEffect(function () {
    // 👇️ scroll to top on page load
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth"
    });
  }, [props.location.key]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    if (from == "web" && role == "Member" && !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.manualTimeFeature)) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Workfolio | Manual Time | ".concat(user === null || user === void 0 ? void 0 : user.displayName))), role == "Member" ? /*#__PURE__*/React.createElement(AddManualTime, _extends({}, props, {
    activeManualTab: activeManualTab
  })) : /*#__PURE__*/React.createElement("div", {
    className: "personal-settings personal-setting-root"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "review-manual-time",
    onSelect: function onSelect(e) {
      setActiveManualTab(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "review-manual-time",
    title: "Review Manual Time ".concat(Number(unreviewedTaskCount) > 1 ? "(".concat(unreviewedTaskCount, ")") : "")
  }, /*#__PURE__*/React.createElement(ManualTimeEntriesReview, _extends({}, props, {
    user: user,
    activeManualTab: activeManualTab,
    setUnreviewedTaskCount: setUnreviewedTaskCount
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "my-manual-time",
    title: "My Manual Time"
  }, /*#__PURE__*/React.createElement(AddManualTime, _extends({}, props, {
    activeManualTab: activeManualTab
  }))))));
};
export default ManualTime;